<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.alerts')">Volver a Alertas</back-profile>
    <block :bordered-header="true">
      <template slot="header">{{ alertTitle(studentAlert) }}</template>
      <template slot="subheader">{{ studentAlert.createdAt | humanizeDate }}</template>

      <div v-if="viewer && viewer.institutionCode === 'cuc.co'">
        <div v-if="studentAlert.alertType">
          <student-alert-reason :alert="getAlertObject()"></student-alert-reason>
          <hr
            v-if="studentAlertReasonWasExposed(studentAlert.alertType, studentAlert.alertType.id)"
            class="separator"
          />
        </div>
      </div>

      <div class="meta-list">
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Fecha:</span>
          <span class="meta-value">{{ studentAlert.createdAt | formatStandardDate }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Registrado por:</span>
          <span class="meta-value">{{
            studentAlert.creator ? studentAlert.creator.name : ""
          }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Responsable:</span>
          <span class="meta-value">
            {{ studentAlert.responsible ? studentAlert.responsible.name : "" }}
          </span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Factor de Riesgo:</span>
          <span class="meta-value">{{ alertRiskFactors }}</span>
        </div>
      </div>
      <div class="description">{{ studentAlert.comment }}</div>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"

import STUDENT_ALERT from "./graphql/StudentAlert.gql"

import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import StudentAlertReason from "./StudentAlertReason.vue"

export default {
  name: "ProfileAlert",
  components: {
    Block,
    BackProfile,
    StudentAlertReason
  },
  props: {
    alertId: {
      type: String
    }
  },
  data() {
    return {
      studentAlert: {
        creator: {
          name: ""
        }
      },
      riskFactorsLabels: {
        ACADEMIC: "Académico",
        ECONOMIC: "Económico",
        VOCATIONAL: "Vocacional",
        INSTITUTIONAL: "Institucional",
        PERSONAL: "Personal",
        OTHER: "Otro"
      }
    }
  },
  apollo: {
    studentAlert: {
      query: STUDENT_ALERT,
      variables() {
        return {
          alertId: this.alertId
        }
      }
    },
    viewer: {
      query: gql`
        query {
          viewer {
            institutionCode
          }
        }
      `
    }
  },
  computed: {
    alertRiskFactors() {
      const riskFactors = this.studentAlert.riskFactors || []
      const labels = riskFactors.map(this.humanizeRiskFactor)
      return labels.join(", ") || "-"
    }
  },
  methods: {
    getAlertObject() {
      const {
        becaDescripcion,
        becaValor,
        becaCobertura,
        porcentajeCreditosAprobados,
        inclusion,
        numSemestres,
        numReintegros,
        periodosAusentes,
        materiasSegundaVezInfo,
        transferenciaInternaInfo,
        materiaUnicaInfo
      } = this.studentAlert.student.data
      return {
        id: this.studentAlert.alertType.id,
        becaDescripcion,
        becaValor,
        becaCobertura,
        porcentajeCreditosAprobados,
        inclusion,
        numSemestres,
        numReintegros,
        periodosAusentes,
        materiasSegundaVezInfo,
        transferenciaInternaInfo,
        materiaUnicaInfo
      }
    },

    humanizeRiskFactor(code) {
      return this.riskFactorsLabels[code] || code
    },

    alertTitle(alert) {
      // If the alert has a type, use that
      if (alert.alertType) {
        return alert.alertType.name
      }
      const riskFactors = alert.riskFactors || []
      const labels = riskFactors.map(this.humanizeRiskFactor)
      const temp = labels.join(", ") || "*Alerta sin factor de riesgo*"
      if (alert.isManual) {
        return `Alerta manual - ${temp}`
      } else {
        return temp
      }
    },

    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },

    studentAlertReasonWasExposed(alertType, alertTypeId) {
      return (
        alertType &&
        (alertTypeId == "44" ||
          alertTypeId == "35" ||
          alertTypeId == "36" ||
          alertTypeId == "43" ||
          alertTypeId == "42" ||
          alertTypeId == "49" ||
          alertTypeId == "50" ||
          alertTypeId == "51" ||
          alertTypeId == "52")
      )
    }
  },

  filters: {
    humanizeDate(date) {
      if (date == null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    },
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date).format("DD/MM/YYYY")
      }
    }
  }
}
</script>

<style scoped>
.meta-list {
  margin-bottom: 30px;
}
.meta-item {
  margin-bottom: 10px;
}

.description {
  margin-bottom: 60px;
}

.separator {
  border: 1px solid rgb(224, 224, 224);
  margin: 1.5em 0em;
  border-top: none;
}
</style>
